import { Link } from "react-router-dom";
import Navbar from "@/components/base/Navbar";
import Footer from "@/components/base/Footer";

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
        <h1 className="text-8xl md:text-[10rem] font-heading text-primary-500/20 select-none pointer-events-none">
          404
        </h1>
        <div className="relative z-10 -mt-16">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-200 mb-2">页面未找到</h2>
          <p className="text-sm text-foreground-500 mb-6">您访问的页面不存在或已被移除。</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-4-line"></i>
            </span>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}